/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Timeline_Track_Range_SummaryInputs */



/**
* | output |
* | --- |
* | "(Range: {start}s - {end}s, Total: {total})" |
*
* @param {Timeline_Track_Range_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_range_summary = /** @type {((inputs: Timeline_Track_Range_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_Range_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`(Plage : ${i?.start}s - ${i?.end}s, Total : ${i?.total})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`(Bereich: ${i?.start}s - ${i?.end}s, Gesamt: ${i?.total})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`(Intervallo: ${i?.start}s - ${i?.end}s, Totale: ${i?.total})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`(Диапазон: ${i?.start}s - ${i?.end}s, Всего: ${i?.total})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`(Rango: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`（范围：${i?.start}s - ${i?.end}s，总计：${i?.total}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`(範囲: ${i?.start}s - ${i?.end}s、合計: ${i?.total})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`(श्रेणी: ${i?.start}s - ${i?.end}s, कुल: ${i?.total})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`(Intervalo: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
	return /** @type {LocalizedString} */ (`(Range: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
});